export default "__VITE_ASSET__DdxQHzUd__"